import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { SelectControl } from 'components/forms/Select';
import { SUB_TYPE_NAME } from 'components/searchAds/constants';

export default class SubTypeControl extends PureComponent {
  static propTypes = {
    input: PropTypes.object,
  };

  render() {
    return <SelectControl {...this.props} qaSelector={SUB_TYPE_NAME} />;
  }
}
